module.exports = __webpack_public_path__ + "img/refresh.87b2615b.svg";